import {z} from '@hono/zod-openapi';

export const conversationUser = z.object({
  id: z.string().uuid().openapi({
    description: 'ID of user',
    example: '123e4567-e89b-12d3-a456-426614174000',
  }),
  externalUserId: z.string().optional().openapi({
    description: 'External ID of user. Only available for DMS users.',
    example: '123e4567-e89b-12d3-a456-426614174000',
  }),
  displayName: z.string().openapi({
    description: 'Display name of user',
    example: 'John Doe',
  }),
  type: z.enum(['PUBLIC', 'DMS']).openapi({
    description: 'Type of user',
    example: 'PUBLIC',
  }),
  createdAt: z.string().datetime().openapi({
    description: 'Timestamp when the user was created',
    example: '2021-01-01T00:00:00.000Z',
  }),
  updatedAt: z.string().datetime().openapi({
    description: 'Timestamp when the user was updated',
    example: '2021-01-01T00:00:00.000Z',
  }),
});

export type ConversationUser = z.infer<typeof conversationUser>;
